/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDocument } from './InternalApiDocument';
import {
    InternalApiDocumentFromJSON,
    InternalApiDocumentFromJSONTyped,
    InternalApiDocumentToJSON,
    InternalApiDocumentToJSONTyped,
} from './InternalApiDocument';
import type { InternalApiUniversalDocumentEntityType } from './InternalApiUniversalDocumentEntityType';
import {
    InternalApiUniversalDocumentEntityTypeFromJSON,
    InternalApiUniversalDocumentEntityTypeFromJSONTyped,
    InternalApiUniversalDocumentEntityTypeToJSON,
    InternalApiUniversalDocumentEntityTypeToJSONTyped,
} from './InternalApiUniversalDocumentEntityType';

/**
 * 
 * @export
 * @interface InternalApiUniversalDocumentsList
 */
export interface InternalApiUniversalDocumentsList {
    /**
     * 
     * @type {InternalApiUniversalDocumentEntityType}
     * @memberof InternalApiUniversalDocumentsList
     */
    entityType: InternalApiUniversalDocumentEntityType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiUniversalDocumentsList
     */
    entityId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUniversalDocumentsList
     */
    entityRef?: string;
    /**
     * 
     * @type {Array<InternalApiDocument>}
     * @memberof InternalApiUniversalDocumentsList
     */
    documents: Array<InternalApiDocument>;
}



/**
 * Check if a given object implements the InternalApiUniversalDocumentsList interface.
 */
export function instanceOfInternalApiUniversalDocumentsList(value: object): value is InternalApiUniversalDocumentsList {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function InternalApiUniversalDocumentsListFromJSON(json: any): InternalApiUniversalDocumentsList {
    return InternalApiUniversalDocumentsListFromJSONTyped(json, false);
}

export function InternalApiUniversalDocumentsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUniversalDocumentsList {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiUniversalDocumentEntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'],
        'entityRef': json['entityRef'] == null ? undefined : json['entityRef'],
        'documents': ((json['documents'] as Array<any>).map(InternalApiDocumentFromJSON)),
    };
}

export function InternalApiUniversalDocumentsListToJSON(json: any): InternalApiUniversalDocumentsList {
    return InternalApiUniversalDocumentsListToJSONTyped(json, false);
}

export function InternalApiUniversalDocumentsListToJSONTyped(value?: InternalApiUniversalDocumentsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiUniversalDocumentEntityTypeToJSON(value['entityType']),
        'entityId': value['entityId'],
        'entityRef': value['entityRef'],
        'documents': ((value['documents'] as Array<any>).map(InternalApiDocumentToJSON)),
    };
}

